import React from 'react';

interface PropertyCommentBadgeProps {
  count: number;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const PropertyCommentBadge: React.FC<PropertyCommentBadgeProps> = ({
  count,
  className = '',
  onClick,
}) => {
  if (count <= 0) return null;

  return (
    <div
      onClick={onClick}
      title={`Este inmueble tiene ${count} ${count === 1 ? 'comentario comercial' : 'comentarios comerciales'}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-black bg-teal-50 hover:bg-teal-100 text-teal-800 border border-teal-200/90 shadow-xs transition-all select-none cursor-default ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="w-3.5 h-3.5 text-teal-600 shrink-0"
      >
        <path
          fillRule="evenodd"
          d="M10 2c-4.418 0-8 3.134-8 7 0 1.76.732 3.376 1.968 4.614A8.17 8.17 0 0 1 3.1 16.892a.75.75 0 0 0 .97 1.026 10.15 10.15 0 0 0 3.864-1.854C8.618 16.275 9.294 16.4 10 16.4c4.418 0 8-3.134 8-7s-3.582-7-8-7Zm-3 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
          clipRule="evenodd"
        />
      </svg>
      <span>{count}</span>
    </div>
  );
};
